import { Box, Skeleton, Stack } from "@mui/material";
import { useTranslation } from "next-i18next";
import { Typography } from "src/components-mui/base/typography/typography";
import type { IDragAndDropSortSectionSkeletonProps } from "./drag-and-drop-sort-section-skeleton.types";

export const DragAndDropSortSectionSkeleton = ({ description }: IDragAndDropSortSectionSkeletonProps) => {
    const { t } = useTranslation("adjust-preferences-modal");

    return (
        <Box
            sx={{
                pt: 2,
            }}
        >
            <Typography
                variant="h5"
                component="h5"
                sx={{
                    fontSize: "xl",
                    fontWeight: "bold",
                }}
            >
                {t("subheadline.order")}
            </Typography>
            {description ? (
                <Typography
                    variant="body2"
                    sx={{
                        fontSize: "sm",
                        py: 2,
                    }}
                >
                    {description}
                </Typography>
            ) : null}
            <Stack
                direction="row"
                sx={{
                    gap: 1,
                    flexWrap: "wrap",
                    p: 1,
                    borderRadius: "8px",
                    backgroundColor: "green.100",
                }}
            >
                <Skeleton variant="rectangular" sx={{ borderRadius: "8px", height: "24px", width: "75px" }} />
                <Skeleton variant="rectangular" sx={{ borderRadius: "8px", height: "24px", width: "205px" }} />
                <Skeleton variant="rectangular" sx={{ borderRadius: "8px", height: "24px", width: "160px" }} />
                <Skeleton variant="rectangular" sx={{ borderRadius: "8px", height: "24px", width: "205px" }} />
            </Stack>
        </Box>
    );
};
